const SI = {
  company: [
    "družba z omejeno odgovornostjo (d.o.o.)",
    "delniška družba (d.d.)",
    "non-profit društvo"
  ],
  legalArrangement: [
    "komanditna delniška družba (k.d.d.)",
    "komanditna družba (k.d.)",
    "društvo"
  ],
  soleProprietorship: [
    "samostojni podjetnik (s.p.)"
  ]
};
export {
  SI as default
};
